const config = {
  'apiDomain': 'https://api.sensiblesurveys.com',
  'apiDomain_test': 'https://api.test.sensiblesurveys.com',
  'apiDomain_dev': 'http://api.ncss.local'
};

export default config;
